// nav.js — Navigation overlay open/close

(function () {
  const toggle = document.getElementById('nav-toggle');
  const overlay = document.getElementById('nav-overlay');
  const body = document.body;

  if (!toggle || !overlay) return;

  function openNav() {
    body.classList.add('nav-open');
    toggle.setAttribute('aria-expanded', 'true');
    overlay.setAttribute('aria-hidden', 'false');
    overlay.focus();
  }

  function closeNav() {
    body.classList.remove('nav-open');
    toggle.setAttribute('aria-expanded', 'false');
    overlay.setAttribute('aria-hidden', 'true');
    toggle.focus();
  }

  toggle.addEventListener('click', function (e) {
    e.preventDefault(); // logo is an <a>; we handle navigation, not the href
    if (body.classList.contains('nav-open')) {
      closeNav();
    } else {
      openNav();
    }
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && body.classList.contains('nav-open')) {
      closeNav();
    }
  });

  // Close when clicking a nav link (same-site navigation)
  overlay.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', function () {
      if (!link.getAttribute('target')) {
        closeNav();
      }
    });
  });

  // Close when clicking anywhere in the overlay that isn't a link
  overlay.addEventListener('click', function (e) {
    if (!e.target.closest('a')) {
      closeNav();
    }
  });
})();
